import { mdiDesktopClassic } from '@mdi/js'

export default {
  title: 'CBT',
  to: 'cbt-hod',
  icon: mdiDesktopClassic,
  resource: 'CbtHeadDepartment',
  action: 'read',
}
